import React from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { DataMigrationWizardContainer } from '../components/data-migration/DataMigrationWizardContainer';
import { Config } from '../services/Config';
import { OnboardingProvider } from '../services/routing/OnboardingProvider';
import { DataMigrationProvider } from '../services/DataMigration/DataMigrationProvider';

export const Route = createFileRoute('/start-migration')({
  staticData: {
    secure: true,
  },
  component: StartMigrationRoute,
});

function StartMigrationRoute() {
  function handleCancelClick() {
    window.location.href = Config.APPLICATION_RECKON_LOGIN_URL;
  }

  return (
    <OnboardingProvider>
      <DataMigrationProvider>
        <DataMigrationWizardContainer onCancelClick={handleCancelClick} />
      </DataMigrationProvider>
    </OnboardingProvider>
  );
}
